import { useCallback } from "react";

import type { ForNodeType } from "@/components/features/_model/types";

type Props = {
	roomChangeDisable: ForNodeType<boolean>;

	onSetViewModel: (
		values: {
			key: "roomChangeDisable";
			value: ForNodeType<boolean>;
		}[],
	) => void;
};

export const useRoomChangeDisable = ({ roomChangeDisable, onSetViewModel }: Props) => {
	const onSetRoomChangeDisable = useCallback(
		(input: boolean) => {
			onSetViewModel([{ key: "roomChangeDisable", value: { ...roomChangeDisable, value: input } }]);
		},
		[onSetViewModel, roomChangeDisable],
	);

	return {
		roomChangeDisable,
		onSetRoomChangeDisable,
	};
};
